import { DAY_END_MIN, DAY_START_MIN, PX_PER_MIN, type ScheduleLesson } from '@skolveckan/shared';
import { LessonBlock, phaseOf } from './LessonBlock';
import { NowLine } from './NowLine';

interface Props {
  lessons: ScheduleLesson[];
  nowMin: number;
  isToday: boolean;
  onOpen: (lesson: ScheduleLesson) => void;
}

export function hourMarks(): number[] {
  const marks: number[] = [];
  for (let m = DAY_START_MIN; m <= DAY_END_MIN; m += 60) marks.push(m);
  return marks;
}

export function DayTimeline({ lessons, nowMin, isToday, onOpen }: Props) {
  const height = (DAY_END_MIN - DAY_START_MIN) * PX_PER_MIN;
  const marks = hourMarks();

  return (
    <div className="timeline" style={{ height }}>
      {marks.map((m) => (
        <div
          key={m}
          className="timeline__hour"
          style={{ top: (m - DAY_START_MIN) * PX_PER_MIN }}
        >
          <span className="timeline__hourlabel">
            {String(Math.floor(m / 60)).padStart(2, '0')}:00
          </span>
          <span className="timeline__hourline" />
        </div>
      ))}

      <div className="timeline__blocks">
        {lessons.map((lesson) => {
          const phase = phaseOf(lesson, nowMin, isToday);
          const progress =
            phase === 'current'
              ? (nowMin - lesson.startMin) / Math.max(lesson.endMin - lesson.startMin, 1)
              : undefined;
          return (
            <LessonBlock
              key={lesson.id}
              lesson={lesson}
              phase={phase}
              progress={progress}
              onOpen={onOpen}
            />
          );
        })}
      </div>

      {isToday && <NowLine nowMin={nowMin} />}
    </div>
  );
}
